import { UseQueryOptions, useQuery } from 'react-query';
import { RemotePublicAccRepo } from '@repository/publicAcc/PublicAccRepo';

const remotePublicAccRepo = new RemotePublicAccRepo();

export const accaPublicKeys = ['acca', 'public'];

export const fetchAccStatusToken = async (code: string) => {
  const { data } = await remotePublicAccRepo.fetchAccStatusToken(code);
  return data;
};

export function useAccStatusToken(code: string, enabled: boolean) {
  return useQuery([...accaPublicKeys, code], () => fetchAccStatusToken(code), {
    enabled,
  });
}

export const fetchAccStatusUser = async (code: string) => {
  const { data } = await remotePublicAccRepo.fetchAccStatusUser(code);
  return data;
};

export const fetchAccApplyResult = async (code: string) => {
  const { data } = await remotePublicAccRepo.fetchAccApplyResult(code);
  return data;
};

export function useAccApplyResult(code: string, options?: UseQueryOptions) {
  return useQuery([...accaPublicKeys, code], () => fetchAccApplyResult(code), options as any);
}

export const fetchAccApplySelfReport = async (code: string) => {
  const { data } = await remotePublicAccRepo.fetchAccApplySelfReport(code);
  return data;
};

export function useAccApplySelfReport(code: string, options?: UseQueryOptions) {
  return useQuery([...accaPublicKeys, code], () => fetchAccApplySelfReport(code), options as any);
}

export const fetchAccApplyGame = async (code: string) => {
  const { data } = await remotePublicAccRepo.fetchAccApplyGame(code);
  return data;
};

export function useAccApplyGame(code: string, options?: UseQueryOptions) {
  return useQuery([...accaPublicKeys, code], () => fetchAccApplyGame(code), options as any);
}

export const fetchAccApplyTip = async (code: string) => {
  const { data } = await remotePublicAccRepo.fetchAccApplyTip(code);
  return data;
};

export function useAccApplyTip(code: string, options?: UseQueryOptions) {
  return useQuery([...accaPublicKeys, code], () => fetchAccApplyTip(code), options as any);
}

export const fetchAccCompetenceProfile = async (code: string) => {
  const { data } = await remotePublicAccRepo.fetchAccCompetenceProfile(code);
  return data;
};

export function useAccCompetenceProfile(code: string, options?: UseQueryOptions) {
  return useQuery([...accaPublicKeys, code], () => fetchAccCompetenceProfile(code), options as any);
}

export const fetchAccCompetenceCurationCompany = async (code: string) => {
  const { data } = await remotePublicAccRepo.fetchAccCompetenceCurationCompany(code);
  return data;
};

export function useAccCompetenceCurationCompany(code: string, options?: UseQueryOptions) {
  return useQuery([...accaPublicKeys, code], () => fetchAccCompetenceCurationCompany(code), options as any);
}

export const fetchAccCompetenceCurationJob = async (code: string) => {
  const { data } = await remotePublicAccRepo.fetchAccCompetenceCurationJob(code);
  return data;
};

export function useAccCompetenceCurationJob(code: string, options?: UseQueryOptions) {
  return useQuery([...accaPublicKeys, code], () => fetchAccCompetenceCurationJob(code), options as any);
}

export const fetchAccApplyVideo = async (code: string) => {
  const { data } = await remotePublicAccRepo.fetchAccApplyVideo(code);
  return data;
};

export function useAccApplyVideo(code: string, options?: UseQueryOptions) {
  return useQuery([...accaPublicKeys, code], () => fetchAccApplyVideo(code), options as any);
}
